/**
 * PERSON SOURCE LOOKUP — Adapter view-side per combobox dual-field.
 *
 * Wrapper su `personSourceApi.getAll` che mappa `PersonSource[]` a
 * `LookupOption[]` (`{id, label}`) — il contratto dei combobox del
 * progetto (DualFieldAutocomplete, EditableField variant `lookup` /
 * `lookupFreeSolo`).
 *
 * Vive qui (entities/personSource) e non in personSourceApi.ts per
 * rispettare il layering: l'api e' UI-agnostica (importa solo @crm/shared
 * + httpClient), questo modulo accetta il dependency su EditableField
 * (LookupOption) perche' e' semanticamente un view-adapter.
 *
 * Centralizza il fetcher usato da PersonFormBody (drawer create/edit) e
 * PersonDetail (inline-edit Fonte): pageSize=20 e search-on-empty come
 * convenzioni concordate. Errori → array vuoto silenzioso (l'autocomplete
 * mostra "Nessuna opzione" senza rumore visivo per l'utente).
 */

import type { LookupOption } from '../../components/EditableField';
import { personSourceApi } from './personSourceApi';

export async function searchPersonSourcesAsLookup(
  groupId: number,
  query: string,
): Promise<LookupOption[]> {
  try {
    const page = await personSourceApi.getAll(groupId, {
      search: query || undefined,
      pageSize: 20,
    });
    return page.items.map((s) => ({ id: s.personSourceId, label: s.name }));
  } catch {
    return [];
  }
}
